export function initHeaderVideoToggle (sectionClass) {

	const buttons = document.querySelectorAll(`section.${sectionClass} .video-toggle:not([data-initialised])`);

	if (! buttons.length) return;

	buttons.forEach(function (button) {

		const videoId = button.getAttribute('aria-controls');
		const video = videoId ? document.getElementById(videoId) : null;

		if (! video) return;

		button.setAttribute('data-initialised', '');

		const sync = function () {
			const paused = video.paused;
			button.classList.toggle('is-paused', paused);
			button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
		};

		button.addEventListener('click', function () {
			if (video.paused) {
				const playAttempt = video.play();
				if (playAttempt) playAttempt.catch(function () {});
			} else {
				video.pause();
			}
		});

		video.addEventListener('play', sync);
		video.addEventListener('pause', sync);
		sync();

	});

}

export default function heroHome () {

	initHeaderVideoToggle('hero-home');

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=hero-home', heroHome);
}
